import axios from 'axios'
import { makeRequest, } from './ApiBase'

export const directoryAdvancedSearch = (data, success, error, cancelSource) => {
  const url = '/Programs/AdvancedSearch'
  const options = {
    method     : 'POST',
    url, 
    cancelToken: cancelSource.token,
    data,
  }
  makeRequest(options, success, error)
}

export const getDetail = (type, id, success, error, signal)  => {
  axios({
    method : 'GET',
    url    : `/Programs/${type}/${id}`, 
    signal : signal != null && signal !== undefined ? signal : new AbortController().signal,
    baseURL: process.env.REACT_APP_API_URL,
  })
    .then(success)
    .catch((reason) => {
      if (reason != null && reason !== undefined && reason.name === 'CanceledError') {
        console.warn(`The request ${reason.config.url} to was cancelled.`)
        error(reason, true)
      } else {
        error(reason)
      }
    })
}

export const getDetailExtra = (programType, programId, occupationId, success, error, signal = new AbortController().signal) => {
  const url = `/Programs/${programType}/${programId}/${occupationId}`
  const options = {
    method: 'GET',
    url, 
    signal,
  }
  makeRequest(options, success, error)
}


export const getCounties = (success, error, cancelSource) => {
  const url = '/Counties'
  const options = {
    method     : 'GET',
    url, 
    cancelToken: cancelSource.token,
  }
  makeRequest(options, success, error)
}

export const getLookup = (endpoint, success, error, cancelSource) => {
  if (!endpoint) {
    console.error('No endpoint provided')
    return
  }
  const url = `Lookup/${endpoint}`
  const options = {
    method     : 'GET',
    url,
    cancelToken: cancelSource.token,
  }
  makeRequest(options, success, error)
}
